import {BBModel} from "../bb_model";

const adminAddress = {
    query(params) {
        const {company} = params;

        return new Promise((resolve, reject) => {
            company.$get('addresses').then(collection =>
                    collection.$get('addresses').then((addresss) => {
                            const models = (Array.from(addresss).map(s => new BBModel.Admin.Address(s)));
                            return resolve(models);
                        }
                        , err => reject(err))

                , err => reject(err));
        });
    }
};


export {
    adminAddress
}